import axios from "@/lib/request";

// 获取产品列表
export const getProductList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/product/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 添加产品
export const addProduct = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/add",
    method: "post",
    data,
  });
};

// 更新产品
export const updateProduct = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/update",
    method: "post",
    data,
  });
};

// 获取产品详情
export const getProductInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/product/info",
    method: "get",
    params,
  });
};

// 删除产品
export const deleteProduct = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/delete",
    method: "post",
    data,
  });
};

// 启用/禁用产品
export const disableProduct = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/disabled",
    method: "post",
    data,
  });
};

// 文件上传
export const uploadFile = (data) => {
  return axios.request({
    url: "/res/file/upload",
    method: "post",
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取产品自定义配置列表
export const getProductConfigList = (params) => {
  return axios.request({
    url: "/v1/admin/product/config/list",
    method: "get",
    params,
  });
};

// 获取产品自定义配置详情
export const getProductConfigInfo = (params) => {
  return axios.request({
    url: "/v1/admin/product/config/info",
    method: "get",
    params,
  });
};

// 保存产品自定义配置
export const saveProductConfig = (data) => {
  return axios.request({
    url: "/v1/admin/product/config/save",
    method: "post",
    data,
  });
};

// 获取省份列表
export const getProvinceList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/province/list",
    method: "get",
    params,
  });
};

// 获取预核保产品列表
export const getPreApprovalList = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/product/list",
    method: "get",
    params,
    appkey: true
  });
};

// 获取预核保产品详情
export const getPreApprovalInfo = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/product/info",
    method: "get",
    params,
    appkey: true
  });
};

// 保存预核保产品配置
export const savePreApproval = (data) => {
  return axios.request({
    url: "/v1/admin/underwrite/product/save",
    method: "post",
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

// 切换预核保产品状态
export const togglePreApprovalStatus = (data) => {
  return axios.request({
    url: "/v1/admin/underwrite/product/disabled",
    method: "post",
    data,
  });
};

// 获取城市列表(用于预核保)
export const getCityList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/city/list",
    method: "get",
    params,
    appkey: true
  });
};

// 获取保险公司列表(员工保用)
export const getInsuranceList = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/insurance/list",
    method: "get",
    params,
    appkey: true
  });
};

// 获取保险公司列表(货运险年保用)
export const getInsuranceCompanyListForYearInsurance = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/list",
    method: "get",
    params,
  });
};

// 获取产品方案列表
export const getSchemeList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/productprice/list",
    method: "get",
    params,
  });
};

// 获取产品方案详情
export const getSchemeInfo = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/product/price",
    method: "get",
    params,
  });
};

// 保存产品方案
export const saveScheme = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/productprice/save",
    method: "post",
    data,
  });
};

// 删除产品方案
export const deleteScheme = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/productprice/delete",
    method: "post",
    data,
  });
};

// 切换产品方案状态
export const toggleSchemeStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/productprice/disabled",
    method: "post",
    data,
  });
};

// 获取应用列表
export const getAppList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/list",
    method: "get",
    params,
  });
};

// 获取价格方案列表
export const getPriceList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/productprice/list",
    method: "get",
    params,
  });
};

// ===== 协议管理相关接口 =====

// 获取协议列表
export const getProtocolList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/agreement/list",
    method: "get",
    params,
  });
};

// 获取协议详情
export const getProtocolInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/agreement/info",
    method: "get",
    params,
  });
};

// 保存协议
export const saveProtocol = (data) => {
  const url = data.id 
    ? "/v1/admin/cmn/agreement/update"
    : "/v1/admin/cmn/agreement/new";
  
  return axios.request({
    url,
    method: "post",
    data,
  });
};

// 删除协议
export const deleteProtocol = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/agreement/delete",
    method: "post",
    data,
  });
};

// 切换协议状态
export const toggleProtocolStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/agreement/disabled",
    method: "post",
    data,
  });
};

// ===== 问答管理相关接口 =====

// 获取问答列表
export const getQuestionList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/product/faq/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取问答详情
export const getQuestionInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/product/faq/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存问答
export const saveQuestion = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/faq/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除问答
export const deleteQuestion = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/faq/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换问答状态
export const toggleQuestionStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/faq/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 问答排序（上移下移）
export const sortQuestion = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/faq/sort",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 保险公司管理相关接口 =====

// 获取保险公司列表
export const getInsuranceCompanyList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存保险公司
export const saveInsuranceCompany = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除保险公司
export const deleteInsuranceCompany = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换保险公司状态
export const toggleInsuranceCompanyStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保险公司排序
export const sortInsuranceCompany = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/sort",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 保险条款管理相关接口 =====

// 获取保险条款列表
export const getInsuranceClauseList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/clause/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存保险条款
export const saveInsuranceClause = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/clause/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除保险条款
export const deleteInsuranceClause = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/clause/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};